import { type ReactNode } from "react";

import { BaseSidebar } from "src/components/SidebarBaseSidebar";
import { SidebarGroups } from "src/components/SidebarSidebarGroups";
import { SidebarHeaderLink } from "src/components/SidebarSidebarHeaderLink";
import { SidebarTabbedBody } from "src/components/SidebarSidebarTabbedBody";
import { SidebarTabProvider } from "src/components/SidebarSidebarTabProvider";
import { SidebarTabs } from "src/components/SidebarSidebarTabs";
import { type SidebarConfig, type SidebarHeaderConfig } from "src/staticData";

interface ConfigSidebarProps {
  config: SidebarConfig;
}

function getSidebarHeader(header: SidebarHeaderConfig | undefined): ReactNode {
  if (header?.type === "link") {
    return <SidebarHeaderLink header={header} />;
  }

  return undefined;
}
export function ConfigSidebar(props: ConfigSidebarProps) {
  const header = getSidebarHeader(props.config.header);

  if (props.config.tabs) {
    return (
      <SidebarTabProvider tabs={props.config.tabs}>
        <BaseSidebar
          header={header}
          tabs={<SidebarTabs tabs={props.config.tabs} />}
          showAccountMenu={props.config.showAccountMenu}
          showCommunicationActions={false}
        >
          <SidebarTabbedBody config={props.config} />
        </BaseSidebar>
      </SidebarTabProvider>
    );
  }

  return (
    <BaseSidebar
      header={header}
      showAccountMenu={props.config.showAccountMenu}
      showCommunicationActions={props.config.showCommunicationActions}
    >
      <SidebarGroups groups={props.config.groups} />
    </BaseSidebar>
  );
}
